/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsUserStatsDtoSchema = z.object({
  totalTournaments: z.optional(z.int()),
  wins: z.optional(z.int()),
  winrate: z.optional(z.number()),
  matchWins: z.optional(z.int()),
  matchLosses: z.optional(z.int()),
  matchWinrate: z.optional(z.number()),
  rank: z.optional(z.int()),
  kda: z.string().nullish(),
});
